module.exports = __webpack_public_path__ + "img/phone.8fe88e28.svg";